import * as React from 'react';
import cx from 'classnames';
import { useI18n } from 'panda-i18n';
import { toJS } from '@formily/reactive';
import { createForm, onFieldInputValueChange } from '@formily/core';
import { FormProvider } from '@formily/react';
import { SchemaField } from '@/form/schema-field';
import { CnButton } from '@/components/cn-button';
import { CnDrawer } from '@/components/cn-drawer';
import { CnBox } from '@/components/cn-box';
import { CnIcon } from '@/components/cn-icon';
import { useDeepCompareEffect } from 'ahooks';
import { splitFilter } from './quick-filter-render';
import './index.scss';
export function CnFilter(props) {
    const { form, formProps = {}, isSticky, onChange, onSubmit: submit, onReset: reset, onSearch: propsOnSearch, children, hiddenFilterButton, components, schema, } = props;
    const $i18n = useI18n();
    // @ts-ignore
    const [, forceUpdate] = React.useState({});
    const [drawerVisible, setDrawerVisible] = React.useState(false);
    const normalizeChild = React.Children.toArray(children);
    const valueChainEffects = React.useCallback((formIns) => {
        onFieldInputValueChange('*', (field) => {
            const { path = '', value } = field.getState();
            // 兼容 PC => H5 一码多端情况，额外设定 mobileProps
            const fieldProps = (field.props || {});
            if (fieldProps.quick || fieldProps.mobileProps?.quick) {
                formIns.setValuesIn(path, value);
                onSubmit(null);
            }
            const values = formIns.getValuesIn('*');
            // proxy数据类型转成普通类型
            onChange && onChange(toJS(values));
        });
    }, [onChange]);
    const formInstance = React.useMemo(() => {
        if (form) {
            form.addEffects('valueChainEffects', valueChainEffects);
            return form;
        }
        // formProps 处理逻辑
        return createForm({
            ...formProps,
            effects: valueChainEffects,
        });
    }, [form]);
    useDeepCompareEffect(() => {
        if (formProps.values) {
            Object.keys(formProps.values).forEach((valueKey) => {
                formInstance.setValuesIn(valueKey, formProps.values?.[valueKey]);
            });
        }
    }, [formProps.values, formInstance]);
    const hideDrawer = () => {
        setDrawerVisible(false);
    };
    const showDrawer = () => {
        setDrawerVisible(true);
    };
    const onSearch = () => {
        const values = formInstance.getValuesIn('*');
        propsOnSearch && propsOnSearch(toJS(values));
        forceUpdate({});
    };
    const onSubmit = (e) => {
        e && e.preventDefault();
        formInstance.submit((res) => {
            submit && submit(toJS(res));
            onSearch();
            hideDrawer();
        });
    };
    const onReset = () => {
        formInstance.reset();
        reset && reset();
    };
    const [quickFilterChild, normalFilterChild] = splitFilter(normalizeChild);
    const classes = cx({
        'cn-ui-m-filter': true,
        'cn-ui-m-filter-sticky': isSticky,
    });
    return (React.createElement(FormProvider, { form: formInstance },
        React.createElement("div", { className: classes },
            quickFilterChild?.length ? (React.createElement("div", { className: "cn-ui-m-filter-header" }, quickFilterChild)) : null,
            !hiddenFilterButton && (React.createElement("div", { className: "cn-ui-m-filter-footer", onClick: showDrawer },
                quickFilterChild?.length ? (React.createElement("div", { className: "cn-ui-m-filter-btn-divider" })) : null,
                React.createElement(CnIcon, { className: "cn-ui-m-filter-btn-icon", type: "icon-filter", size: "small" }),
                React.createElement("span", { className: "cn-ui-m-filter-btn-text" }, $i18n.get({
                    id: '31255239508234240.CNTM',
                    dm: '筛选',
                }))))),
        React.createElement(CnDrawer, { visible: drawerVisible, title: $i18n.get({
                id: '31255239508234240.CNTM',
                dm: '筛选',
            }), placement: "bottom", onClose: hideDrawer, cancelProps: {
                children: null,
                visible: false,
            }, okProps: {
                children: null,
                visible: false,
            }, footer: React.createElement(CnBox, { flex: 1, spacing: 4, direction: "row", justify: "space-between" },
                React.createElement(CnButton, { fullWidth: true, onClick: hideDrawer, size: "large" }, $i18n.get({ id: 'Cancel', dm: '取消' })),
                React.createElement(CnButton, { fullWidth: true, size: "large", onClick: onReset }, $i18n.get({ id: 'Reset', dm: '重置' })),
                React.createElement(CnButton, { fullWidth: true, size: "large", type: "primary", 
                    // @ts-ignore
                    onClick: (e) => onSubmit(e, 'normal') }, $i18n.get({
                    id: '31255238698733568.CNTM',
                    dm: '查询',
                }))) },
            React.createElement(SchemaField, { schema: schema, components: components }),
            normalFilterChild)));
}
CnFilter.displayName = 'CnFilter';
CnFilter.defaultProps = {
    formProps: {},
    isSticky: true,
};
